
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { singleton, empty, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { WarningAlert, InformationAlert } from "../../Components/Alert.js";
import { filter, empty as empty_1, singleton as singleton_1, map, toArray, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { TableControlElement$1, TableControl$1 } from "../../Widgets/Table/Table.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

function ModalContent(props) {
    let elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => {
        let matchValue, msg, elems;
        return append((matchValue = props.InfoMessage, (matchValue == null) ? (empty()) : ((msg = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["px-5", "pb-4"])], (elems = [createElement(InformationAlert, {
            Label: msg,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))))), delay(() => {
            let TableRows, Options;
            return singleton(createElement(InfiniteTable, (TableRows = toArray(props.Tools), (Options = {
                BorderStyle: "full",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["name", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
                WithQueryParameters: false,
            }, {
                ColumnDefinitions: [new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(4, [dto.ImageUrl])), "none", "image"), new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text")],
                Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.add"), Shipment_Add(), (row_5) => {
                    props.OnAddToolIds(map((row_6) => row_6.ToolId, row_5));
                }, false, false, "")])),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function SelectToolModal(props) {
    let elems;
    const patternInput = useTranslation();
    const isAssignedToReceiver = props.AssignedReceiverId != null;
    let filteredTools;
    const matchValue = props.SelectedStorageId;
    if (matchValue == null) {
        filteredTools = empty_1();
    }
    else {
        const selectedStorageId = matchValue;
        filteredTools = filter((tool_1) => {
            const matchValue_1 = tool_1.AssignedReceiverId;
            if (isAssignedToReceiver) {
                if (matchValue_1 == null) {
                    return false;
                }
                else {
                    return true;
                }
            }
            else if (matchValue_1 != null) {
                return false;
            }
            else {
                return true;
            }
        }, filter((tool) => (tool.StorageId === selectedStorageId), props.Tools));
    }
    return createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (props.SelectedStorageId == null) ? reactElement("div", createObj(ofArray([["className", join(" ", ["px-5"])], (elems = [createElement(WarningAlert, {
            Label: patternInput[0]("set.add_tool_dialog.storage_not_selected_information"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))) : createElement(ModalContent, {
            InfoMessage: unwrap(isAssignedToReceiver ? "set.add_tool_dialog.receiver_assigned_information" : "set.add_tool_dialog.storage_assigned_information"),
            OnAddToolIds: props.OnAddToolIds,
            Tools: filteredTools,
        }),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    });
}

